var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGcpDndSmallDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .gcp-disabled{fill:#c8c8c8;fill-rule:evenodd}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_sync_gcp_storage_40_disabled",
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_80",
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#fff",
    stroke: "#e8e8e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-1",
    d: "M14.209 4.393h.063l-.038-.031 2.382-2.382v-.043a7.742 7.742 0 0 0-12.6 3.777.971.971 0 0 1 .128-.042 5.555 5.555 0 0 1 4.138-.82.072.072 0 0 1 .05-.013 4.3 4.3 0 0 1 5.881-.447h-.012",
    className: "gcp-disabled",
    transform: "translate(7.866 11.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-2",
    d: "M24.09 7.044a7.78 7.78 0 0 0-2.339-3.77l-2.418 2.417A4.3 4.3 0 0 1 20.911 9.1v.428a2.152 2.152 0 0 1 0 4.3h-4.3l-.007.007v3.415h-.018l.025.025h4.3A5.6 5.6 0 0 0 24.09 7.044",
    className: "gcp-disabled",
    transform: "translate(2.768 10.171)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-3",
    d: "M7.059 24.325h4.3v-3.444h-4.3a2.112 2.112 0 0 1-.884-.194l-2.488 2.488-.007.026a5.572 5.572 0 0 0 3.378 1.124",
    className: "gcp-disabled",
    transform: "translate(8.006 3.101)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-4",
    d: "M5.565 8a5.6 5.6 0 0 0-3.379 10.028l2.5-2.5a2.151 2.151 0 1 1 2.846-2.847l2.5-2.5A5.592 5.592 0 0 0 5.565 8",
    className: "gcp-disabled",
    transform: "translate(9.5 8.254)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGcpDndSmallDisabled);
export default __webpack_public_path__ + "static/media/gcp-dnd-small-disabled.f42105854d4bdb73fac675c5ec63add3.svg";
export { ForwardRef as ReactComponent };